import { render, staticRenderFns } from "./create.vue?vue&type=template&id=c0be4ae6&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0be4ae6')) {
      api.createRecord('c0be4ae6', component.options)
    } else {
      api.reload('c0be4ae6', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=c0be4ae6&", function () {
      api.rerender('c0be4ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/reports/create.vue"
export default component.exports